<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Expedição - Alterar Pedido/Armazém - Por Lote"
>
  <po-input
    [p-auto-focus]="true"
    class="po-md-12"
    name="etiquetalote"
    [(ngModel)]="etiquetalote"
    p-label="Lote"
    (keyup.enter)="biparEtiqueta()"
  >
  </po-input>

  @if ( etiquetaExpedicaoPedido.CZ02COD != '') {
    <po-container class="po-md-12">
      <po-button class="po-md-12" p-kind="secondary" p-label="Gerar Etiqueta Cliente" (p-click)="openModalImpressora()"></po-button>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Etiqueta Expedição" [p-value]="etiquetaExpedicaoPedido.CZ02COD"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Cód Romaneio" [p-value]="etiquetaExpedicaoPedido.CZ02CODZ00"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Lote" [p-value]="etiquetaExpedicaoPedido.CZ02LOTE"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Volume" [p-value]="etiquetaExpedicaoPedido.NZ02VOLUME"></po-info>

      <div class="po-sm-12 po-md-3 po-mt-2 po-row">
        <po-info class="po-font-text-small" p-label="Container" [p-value]="etiquetaExpedicaoPedido.NZ02CTNR"></po-info>
        <po-button p-kind="secondary" class="po-mt-2 po-ml-2" p-label="Alterar" (p-click)="alterarContainer()"></po-button>
      </div>
      <div class="po-sm-12 po-md-3 po-mt-2 po-row">
        <po-info class="po-font-text-small" p-label="UR" [p-value]="etiquetaExpedicaoPedido.CZ02UR"></po-info>
        <po-button p-kind="secondary" class="po-mt-2 po-ml-2" p-label="Alterar" (p-click)="alterarUR()"></po-button>
      </div>

      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Produto" [p-value]="etiquetaExpedicaoPedido.CB1COD"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Descrição Produto" [p-value]="etiquetaExpedicaoPedido.CB1DESC"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Pedido" [p-value]="etiquetaExpedicaoPedido.CC5NUM"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Peso" [p-value]="etiquetaExpedicaoPedido.NZ02PESO"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Qtde Pc" [p-value]="etiquetaExpedicaoPedido.NB8QTDORI"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Nome Cliente" [p-value]="etiquetaExpedicaoPedido.CA1NOME"></po-info>


      <po-button class="po-md-12" p-kind="secondary" [p-label]="labelTransferencia" (p-click)="transfereEstoque()"></po-button>

      <po-button
        class="po-sm-12 po-lg-12"
        p-kind="secondary"
        p-label="Transferir para o 98"
        [p-disabled]="transferencia98EmAndamento"
        (p-click)="transferirPara98()">
      </po-button>

      <po-divider class="po-md-12"></po-divider>

      <po-input
        [p-auto-focus]="true"
        class="po-md-12"
        name="novoPedido"
        [(ngModel)]="novoPedido"
        p-label="Novo Pedido"
      >
      </po-input>
      <po-button
        class="po-md-12"
        p-kind="secondary"
        p-label="Alterar Pedido"
        [p-disabled]="transferenciaPedidoEmAndamento"
        (p-click)="alterarPedido()">
      </po-button>
    </po-container>
  }

</po-page-default>

<po-modal #transferirLoteModal p-title="Transferência" [p-primary-action]="transferirLoteAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-12"
      name="motivoTransferencia"
      [(ngModel)]="motivoTransferencia"
      p-label="Motivo da Transferência"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="zprColumnsFilters"
      [p-field-format]="zprFieldFormaterFilters"
      [p-filter-service]="zprService"
      [p-advanced-filters]="zprAdvancedFilters"
      [p-literals]="{ modalTitle: 'Motivo da Transferência' }"
      [p-required]="true"
      [p-auto-height]="true">
    </po-lookup>
  </form>
</po-modal>

<po-modal #transferir98Modal p-title="Transferir para o 98">
  <po-info
    class="po-sm-12 po-lg-12"
    p-label="Romaneio"
    [p-value]="romaneioConfirmacao98">
  </po-info>
  <po-info
    class="po-sm-12 po-lg-12 po-mt-2"
    p-label="Ação"
    p-value="O lote será retirado do romaneio e transferido para o Armazém 98.">
  </po-info>
  <po-info
    class="po-sm-12 po-lg-12 po-mt-2"
    p-label="Confirmação"
    p-value="Deseja continuar?">
  </po-info>
  <po-modal-footer>
    <po-button p-label="Sim" [p-disabled]="transferencia98EmAndamento" (p-click)="transferir98ModalConfirmar()"></po-button>
    <po-button p-label="Não" [p-disabled]="transferencia98EmAndamento" (p-click)="transferir98ModalCancelar()"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #alterarPedidoModal p-title="Alterar Pedido">
  <div>
    O lote {{loteConfirmacaoPedido}} está vinculado ao romaneio {{romaneioConfirmacaoPedido}}.
    Deseja excluir o lote deste romaneio para continuar a transferência?
  </div>
  <po-modal-footer>
    <po-button p-label="Sim" [p-disabled]="transferenciaPedidoEmAndamento" (p-click)="alterarPedidoModalConfirmar()"></po-button>
    <po-button p-label="Não" [p-disabled]="transferenciaPedidoEmAndamento" (p-click)="alterarPedidoModalCancelar()"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #alterarContainerModal p-title="Container" [p-primary-action]="alterarContainerAction">
  <form #f="ngForm">
    <po-number
      class="po-md-12"
      name="nroContainer"
      [(ngModel)]="nroContainer"
      p-label="Container">
    </po-number>
  </form>
</po-modal>

<po-modal #alterarURModal p-title="UR" [p-primary-action]="alterarURAction">
  <form #f="ngForm">
    <po-combo class="po-md-12"
      name="urselecionada"
      p-label="UR"
      [(ngModel)]="URselecionada"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrromaneio/UR/listaCombo/{{etiquetaExpedicaoPedido.CB1COD}}"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-clean="true">
    </po-combo>
  </form>
</po-modal>

<po-modal #impressaoEtiquetaModal p-title="Impressão" [p-primary-action]="gerarEtiquetaClienteAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-6"
      name="impressora"
      [(ngModel)]="impressora"
      p-label="Impressora"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="zprColumnsFilters"
      [p-field-format]="zprFieldFormaterFilters"
      [p-filter-service]="zprService"
      [p-advanced-filters]="zprAdvancedFilters"
      [p-literals]="{ modalTitle: 'Impressora' }"
      [p-required]="true"
      [p-auto-height]="true">
    </po-lookup>

    <po-select
      class="po-md-6"
      name="nCopias"
      p-label="Nº Cópias"
      [(ngModel)]="nCopias"
      [p-options]="[
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
      ]"
    >
    </po-select>

    <po-switch
      class="po-md-6 po-mt-2"
      name="lInstrucao"
      [(ngModel)]="lInstrucao"
      p-label="Também imprime instrução?"
      p-label-off="Não, apenas identificação."
      p-label-on="Sim, por favor."
      [p-label-position]="labelPosition"
    >
    </po-switch>
  </form>
</po-modal>
